import { render, staticRenderFns } from "./ModalWorkspaceInfo.vue?vue&type=template&id=1f63a3aa&"
import script from "./ModalWorkspaceInfo.vue?vue&type=script&lang=js&"
export * from "./ModalWorkspaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalWorkspaceInfo.vue?vue&type=style&index=0&id=1f63a3aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports